import { Component } from '@angular/core';

@Component({
    selector: 'ct-gradient-text',
    templateUrl: 'gradient-text.component.html',
    styleUrls: ['gradient-text.component.less'],
})
export class GradientTextComponent {
}
